import { Address } from "./address.model";
import { Contact } from "./contact.model";

export interface FacilityDetail {
    id: number;
    year: number;
    name?: string;
    facilityId: number;
    officialName: string;
    siccode: string;
    naicscode: string;
    triid: string;
    employeeCount: number;
    dunBradstreetCode: string;
    parentName: string;
    parentDunBradstreetCode: string;
    technicalContactId?: number;
    publicContactId?: number;
    mailingAddressId?: number;
    realAddressId?: number;
    corporateDivision: string;
    customerId: number;
    isNew?: boolean;
    active: boolean;
    hasWasteTreatments: boolean;
    hasWaterBodies: boolean;
    hasPublicallyOwnedTreatmentWorks: boolean;
    hasOffsiteLocations: boolean;
    createdDateTime?: Date;
    updatedDateTime?: Date;
    technicalContact?: Contact;
    publicContact?: Contact;
    mailingAddress?: Address;
    realAddress?: Address;
    completedDateTime?: Date;
    completedBy?: number;
    completedByName?: string;
    status?: FacilityDetailStatus;
    // Form R Part I facility-level header fields.
    federalFacilityIndicator?: boolean | null;
    gocoIndicator?: boolean | null;
    biaCode?: string;
    dunBradstreetCode2?: string;
    foreignParentName?: string;
    foreignParentDunBradstreetCode?: string;
    // Explicit per-section "Not Applicable" flags (null = undecided/shown, true = N/A/hidden, false = applicable).
    potwNotApplicable?: boolean | null;
    waterBodyNotApplicable?: boolean | null;
    offsiteLocationNotApplicable?: boolean | null;
    wasteTreatmentNotApplicable?: boolean | null;
}

export enum FacilityDetailStatus {
    Active = 0,
    Locked = 1,
    Unpaid = 2
}
